import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import AppSidebar from './AppSidebar';
import TittiChatWidget from '@/components/TittiChatWidget';

/**
 * AppShell - Global layout for authenticated pages.
 * Renders a fixed/sticky left sidebar and a main content area.
 * The mobile hamburger button sits at the top-left of the content area.
 */
export default function AppShell({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // Close drawer on route change
  React.useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex">
      <AppSidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />

      <div className="flex-1 min-w-0 flex flex-col">
        {/* Mobile top bar (hamburger only) */}
        <div className="lg:hidden sticky top-0 z-30 h-12 bg-background/80 backdrop-blur-sm border-b border-border flex items-center px-3">
          <button
            onClick={() => setMobileOpen(true)}
            className="p-2 rounded-md text-foreground hover:bg-secondary transition-colors"
            data-testid="mobile-menu-open"
            aria-label="Åpne meny"
          >
            <Menu size={18} strokeWidth={1.75} />
          </button>
          <span className="ml-2 text-sm font-semibold tracking-tight text-foreground">RetailMaster</span>
        </div>

        <main className="flex-1 min-w-0">
          {children}
        </main>
      </div>
      <TittiChatWidget />
    </div>
  );
}
